define( function() {
	"use strict";

	return [];
} );



//////////////////
// WEBPACK FOOTER
// /srv/_versions/easypost-web/easypost-web-201706012359-95877d6b9a-master/~/jquery/src/var/arr.js
// module id = 113
// module chunks = 1